// Flow, phases, quiz metadata, shared answer store, loop copy lookup tables
export const state = { cur: 0, D: {} };

export const FLOW = [
  's-land', 's-welcome', 'sp-gender', 'sp-age', 's-land2', 's0', 's1', 's2', 's3', 'mqi-a', 's4', 's5', 's6', 's7', 's8', 'react-tried', 'hq1', 'ms1',
  's10', 's11', 's12', 's13', 'mqi-b', 's15', 's16', 's17', 's18', 's19', 's20', 'hq2', 'ms2', 'sq1', 's21', 's22',
  's23', 'sq2', 's24', 's25', 's26', 'hq3', 's27', 's28', 's29', 's30', 's31', 's32', 'react-a', 's34', 's-loading'
];
export const PHASES = {
  's-land': '', 's-welcome': 'Your profile', 'sp-gender': 'Your profile', 'sp-age': 'Your profile', 's-land2': '', 's0': 'Your profile', 's1': 'Your profile', 's2': 'Your profile',
  's3': 'Your profile', 'mqi-a': 'Profile preview', 's4': 'What MindLift does',
  's5': 'Your profile', 's6': 'Your profile', 's7': 'Your profile', 's8': 'Your profile', 'react-tried': 'Your profile',
  'hq1': 'Your profile', 'ms1': 'Checkpoint', 's10': 'Your patterns', 's11': 'Your patterns',
  's12': 'Your patterns', 's13': 'Your patterns', 'mqi-b': 'Loop pattern', 's15': 'Your patterns',
  's16': 'Your patterns', 's17': 'Your patterns', 's18': 'Your patterns', 's19': 'Your patterns',
  's20': "You're not alone", 'hq2': 'Your patterns', 'ms2': 'Checkpoint', 'sq1': 'Your training', 's21': 'Your training', 's22': 'Your training',
  's23': 'Your training', 'sq2': 'Your training', 's24': 'Your training', 's25': 'Your training', 's26': 'Your training',
  'hq3': 'Your training', 's27': 'Your training', 's28': 'Your training', 's29': 'Your training', 's30': 'Your training',
  's31': 'Your training', 's32': 'Your training', 'react-a': '', 's34': 'Final step',
  's-loading': ''
};
// Order here is not FLOW order — only membership (which ids count as answered questions) may be relied on.
export const Q_IDS = [
  's0', 'sp-gender', 'sp-age', 'hq1', 'hq2', 'hq3', 's1', 's2', 's3', 's5', 's6', 's7', 's8', 's10', 's11', 's12', 's13', 's15', 's16', 's17', 's18',
  's19', 'sq1', 's21', 's22', 's23', 'sq2', 's24', 's25', 's27', 's28', 's29', 's30', 's31', 's32', 's34'
];
/** Headway-style phase line: 4 nodes. Every screen maps to exactly one node; the mapping is non-decreasing along FLOW. */
export const NODE_LABELS = ['Profile', 'Patterns', 'Training', 'Final step'];

export function phaseNodeFor(sid) {
  if (sid === 'ms2') return 1; // second checkpoint closes the Patterns phase
  if (sid === 's-loading') return 3;
  if (sid === 'react-a') return 2;
  const label = PHASES[sid] || '';
  if (label === 'Final step') return 3;
  if (label === 'Your training') return 2;
  if (label === 'Your patterns' || label === 'Loop pattern' || label === "You're not alone") return 1;
  return 0; // Your profile, Profile preview, What MindLift does, Checkpoint (ms1), landing, welcome
}
export const TOASTS = [
  { at: 's5', msg: '🔥 Your loop profile is taking shape' },
  { at: 's8', msg: '💡 Clues stack up — full loop profile at the end' },
  { at: 'ms1', msg: '🎯 First checkpoint — your loop profile is forming' },
  { at: 's13', msg: '🧠 Halfway — your loop profile is getting sharper' },
  { at: 'ms2', msg: '🔄 Final stretch — full loop profile almost ready' },
  { at: 's25', msg: '⚡ Last 8 — lock in your loop profile' },
  { at: 's34', msg: '🏁 One step left — then your loop profile unlocks' }
];

export const LOOP_NAMES = {
  rumination: 'Replaying moments over and over',
  anticipation: 'Jumping to worst-case scenarios',
  critic: 'Being hard on myself',
  scatter: 'My mind keeps jumping everywhere',
  shutdown: "I shut down when it's too much",
  night: "My mind won't switch off at night"
};
/** Short titles for plan / result “Main loop” tiles (matches loop profile naming) */
export const LOOP_DISPLAY_TITLES = {
  rumination: 'Replay Loop',
  anticipation: 'What-If Loop',
  critic: 'Inner Critic Loop',
  scatter: 'Restless Mind',
  shutdown: 'Stuck Loop',
  night: 'Night Spiral',
  balanced: 'Balanced Mind'
};

/** Strip leading loop profile name from pattern HTML (e.g. bold title line before body copy). */
export function stripLeadingLoopProfileTitle(html) {
  if (!html || typeof LOOP_DISPLAY_TITLES === 'undefined') return html;
  var out = String(html);
  for (var k in LOOP_DISPLAY_TITLES) {
    if (!Object.prototype.hasOwnProperty.call(LOOP_DISPLAY_TITLES, k)) continue;
    var t = LOOP_DISPLAY_TITLES[k];
    if (!t) continue;
    var esc = t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    out = out.replace(new RegExp('^\\s*<strong>\\s*' + esc + '\\s*</strong>\\s*(?:<br\\s*/?>)+', 'i'), '');
    out = out.replace(new RegExp('^\\s*' + esc + '\\s*(?:<br\\s*/?>)+', 'i'), '');
  }
  return out;
}

/** Balanced Mind (composite under 35) — main pattern + mid-quiz variants (see funnel-analysis.js, funnel-flow.js) */
export const BALANCED_MAIN_PATTERN =
  'Your mind can get pulled into loops &mdash; but you&rsquo;re able to step back and regain perspective.<br>This isn&rsquo;t luck. It&rsquo;s a skill you already use.<br>The shift is making it more consistent and easier to access.';
export const BALANCED_MQI_A_BODY =
  'You already have some space between thoughts and reactions.<br>That&rsquo;s a strong starting point.<br><br>Your mind still drifts at times, but it doesn&rsquo;t fully take over.<br>And that makes change much easier.';
export const BALANCED_MQI_A_FACT =
  'People who can step back from their thoughts, even sometimes<br>tend to feel more stable and less overwhelmed.<br><br>It&rsquo;s not about having fewer thoughts,<br>but about not getting pulled into all of them.';
export const BALANCED_MS1 =
  'Next, we&rsquo;ll look at where your balance holds and where it starts to slip.<br><br>Losing balance sometimes is normal.<br>We&rsquo;ll focus on helping you recover it faster and more easily.';
export const BALANCED_MQI_B_TRAINING =
  'We&rsquo;ll build on what&rsquo;s already working with small, repeatable resets you can use in real moments.<br><br>Not big changes. Just more consistency.<br>Over time, stepping back will feel more automatic.';

/** What research shows — same copy for every loop on mqi-a (see buildMqiA in funnel-flow.js) */
export const MQI_A_FACT =
  'Self-compassion research shows that kinder, believable self-talk works better than harsh inner criticism — and better than forced positivity.<br><br>You can grow without turning against yourself.';

/** Mid-quiz insight A — warm, plain-language copy (see buildMqiA in funnel-flow.js) */
export const MQI_A = {
  rumination: {
    body:
      'You tend to revisit moments after they pass. Trying to understand, fix, or replay what was said.<br>This loop feels useful, but rarely brings closure. There\'s already more space here than it seems.'
  },
  anticipation: {
    body:
      'Your mind runs ahead, scanning for what might go wrong. It feels like preparation, but keeps you on edge.<br>This pull isn\'t fixed. You already have some space to step back.'
  },
  critic: {
    body:
      'Your mind is quick to judge and slow to settle. The standard keeps shifting.<br>This voice feels convincing, but it\'s learned, not truth. And it\'s not as strong as it seems.'
  },
  scatter: {
    body:
      'Your attention moves quickly between thoughts. It\'s hard to stay with one thing for long.<br>This isn\'t a lack of discipline, it\'s a busy system. And it can be gently trained.'
  },
  shutdown: {
    body:
      'When things build up, your system slows down. You pause, disconnect, or feel stuck.<br>This isn\'t weakness, it\'s protection kicking in. And it doesn\'t have to stay this way.'
  },
  night: {
    body:
      'When things get quiet, your mind gets louder. Thoughts stretch and loop at night.<br>It can feel like you need to figure everything out before rest. But that keeps the loop going.'
  }
};

/** Mid-quiz insight B — pattern card + what training will feel like (buildMqiB); LOOP_DESC mirrors .pattern for analysis */
export const MQI_B = {
  rumination: {
    pattern:
      'Your mind tends to go back to moments after they happen &mdash; replaying, analyzing, trying to make sense of them.<br>This isn&rsquo;t a flaw. It&rsquo;s your mind trying to resolve things.<br>The shift is learning to let moments end without reopening them.',
    training:
      'We&rsquo;ll help you step out of replay in real time<br>with small resets that interrupt the loop without forcing it.<br><br>Less going over. More letting go.<br>Repeated until your mind starts to settle on its own.'
  },
  anticipation: {
    pattern:
      'Your mind moves ahead, scanning for what could go wrong &mdash; trying to stay prepared.<br>This isn&rsquo;t overthinking. It&rsquo;s a sensitive alert system.<br>The shift is creating space between the thought and the reaction.',
    training:
      'We&rsquo;ll help you notice &ldquo;what if&rdquo; thoughts without chasing them<br>using short resets that create space, not pressure.<br><br>Less solving. More observing.<br>Repeated until the urgency softens.'
  },
  critic: {
    pattern:
      'Your mind tends to judge quickly and raise the bar.<br>It&rsquo;s hard to feel like you&rsquo;ve done enough.<br>This voice feels true, but it&rsquo;s learned, not fixed.<br>The shift is building a steadier, more balanced inner voice.',
    training:
      'We&rsquo;ll introduce steadier, believable self-talk<br>not forced positivity, but something you can actually accept.<br><br>Less pressure. More balance.<br>Repeated until the tone inside changes.'
  },
  scatter: {
    pattern:
      'Your attention moves quickly from one thought or task to another.<br>This isn&rsquo;t a lack of discipline. It&rsquo;s a busy system.<br>The shift is having something simple to return to.',
    training:
      'We&rsquo;ll give you simple anchors to come back to<br>short resets that gently guide your attention back.<br><br>Less chasing. More returning.<br>Repeated until focus feels easier.'
  },
  shutdown: {
    pattern:
      'When things feel like too much, your system pulls back.<br>Energy drops, and it&rsquo;s hard to move forward.<br>This is your system trying to protect you.<br>The shift is gentle movement, not pushing harder.',
    training:
      'We&rsquo;ll use tiny, manageable steps<br>so progress feels possible even on low-energy days.<br><br>Less force. More momentum.<br>Repeated until movement returns naturally.'
  },
  night: {
    pattern:
      'When everything gets quiet, your mind stays active &mdash; thinking, replaying, or spiraling.<br>Your mind isn&rsquo;t the problem &mdash; timing is.<br>The shift is learning to let thoughts settle instead of solving them.',
    training:
      'We&rsquo;ll help your mind wind down instead of work through<br>with gentle shifts that ease you out of the loop.<br><br>Less solving. More settling.<br>Repeated until rest comes easier.'
  }
};

export const LOOP_DESC = {
  rumination: MQI_B.rumination.pattern,
  anticipation: MQI_B.anticipation.pattern,
  critic: MQI_B.critic.pattern,
  scatter: MQI_B.scatter.pattern,
  shutdown: MQI_B.shutdown.pattern,
  night: MQI_B.night.pattern
};
/**
 * Personalise spec §10: one acknowledgment line per answer, shown on the NEXT
 * question screen (via ECHO_SOURCE + echoFor() in js/funnel-flow.js). Keyed by
 * the container id of the ANSWERED question. Scale questions use three
 * buckets (low 1–2, mid 3, high 4–5); multi-select questions use the
 * first-picked value plus an optional `more` tail when 2+ are picked.
 */
export const ECHOES = {
  c0: {
    rumination: "Replaying it after the fact — we'll help you know when the replay's done its job.",
    anticipation: "Jumping to worst-case first — that's your mind trying to protect you, just too early.",
    critic: "Hard on yourself when it runs — we'll work on a voice that pushes without draining you.",
    scatter: "Mind jumping everywhere — that's a busy system, not a broken one.",
    shutdown: "Shutting down when it's too much — that's protection, not failure.",
    night: "Mind won't switch off at night — we'll help it wind down instead of solve."
  },
  c1: {
    low: "Stepping out easily most of the time — that's a real skill we can sharpen further.",
    mid: "Sometimes you can step out, sometimes not — that in-between is exactly where we start.",
    high: 'Almost never stepping out — that’s the stickiness we’ll work on.'
  },
  c2: {
    morning: "Morning is when it grabs you first — we'll build something for right when you wake up.",
    transitions: 'It catches you in the gaps between things — small moments, small resets.',
    conflict: "Replaying conversations after they end — that's a very common shape for this.",
    decisions: "Decisions are where it tightens — we'll give you a way through, not just a way to think about it.",
    night: "Night is when it runs loudest — that's worth training for specifically.",
    constant: "Feels like it's always on — we'll look for the cracks where a reset can fit."
  },
  c5: {
    distract: 'Reaching for distraction first — it buys time, but the thought is usually still there after.',
    suppress: 'Pushing the thought away first — that often makes it louder, not quieter.',
    follow: 'Following it deeper first, trying to think your way out — a very human reflex.',
    talk: "Talking to someone first — reassurance helps in the moment, and we'll build on that.",
    nothing: 'Waiting it out first — that takes real patience, and we can make it shorter.',
    more: ' We noted the rest, too.'
  },
  c6: {
    low: "Minutes, not longer — that's a shorter fuse than most people realise they have.",
    mid: 'About half a day — long enough to cost you the rest of it.',
    high: "Days at a time — that's not a mood, that's a loop that needs an exit."
  },
  c7: {
    failure: "“You always do this” — that's the all-or-nothing voice, and it's louder than the facts.",
    danger: "Straight to worst-case — that's your alarm system working overtime, not you being weak.",
    weak: "Comparing yourself to some imagined ‘normal’ — that comparison is the loop, not the truth.",
    noise: "No words, just dread — that's still information, even without a sentence attached.",
    solve: '“I need to figure this out” on repeat — the solving is what keeps it open.'
  },
  c10: {
    brutal: "That harsh voice isn't discipline — it's part of the loop.",
    harsh: "Being on your own case that often is exhausting — and it's trainable.",
    moderate: 'On-and-off criticism still shapes your day more than it seems.',
    quiet: "Being able to step back sometimes is a real skill — we'll build on it."
  },
  c11: {
    low: 'Rarely pulled out of the room — that presence is worth protecting.',
    mid: "Often pulled into your head with people you care about — that's a real cost, and fixable.",
    high: "Constantly pulled away, even with people you care about — that's exactly what we're targeting."
  },
  c12: {
    low: "Barely touches your work — good, we'll keep it that way.",
    mid: 'You notice it at work sometimes — that’s the kind of drag we can quietly remove.',
    high: "It affects you at work most days — that's a lot of hours lost to something fixable."
  },
  c15: {
    phone: "Phone-first mornings hand your attention to the loop before you're awake.",
    urgency: 'Starting the day already behind primes the loop to run.',
    worry: 'Waking into worry is one of the most common loop patterns there is.',
    slow: "Easing in slowly — that's a real asset, and we'll protect it.",
    move: 'Moving your body before your brain kicks in — a good instinct to build on.'
  },
  c16: {
    low: "Minutes, then it's gone — that's a fast recovery most people would envy.",
    mid: "Days before it lets go — long enough to shape your whole week.",
    high: "It doesn't seem to let go on its own — that's exactly what training an exit is for."
  },
  c17: {
    low: "Working against you most days — thanks for being honest, that's what your plan calibrates to.",
    mid: "Some days it works with you, some days it doesn't — that's the average, and it can shift.",
    high: "Mostly working with you already — we'll help make that the default, not the exception."
  },
  c18: {
    presence: "Being more present, less in your head — that's the shift most people notice first.",
    decisions: "Deciding without spiralling — we'll build that as a specific skill, not a hope.",
    sleep: 'Easier nights — sleep is often the first thing that gets better.',
    work: 'Less noise at work — that’s usually the loudest place the loop shows up.',
    people: 'Showing up more for people — that’s worth training for directly.'
  },
  csq1: {
    work: "Work pressure is driving this right now — we'll shape the plan around real deadlines, not ideal conditions.",
    relationship: "It's spilling into how you connect — that's worth protecting, and we'll work on it directly.",
    transition: 'A big transition will do this — new chapters shake loose old loops.',
    sleep: "Sleep tipping first is a strong signal — we'll prioritise what helps you wind down.",
    enough: "You're done with it — that's a real motivator, and we'll put it to use.",
    noticed: 'Catching the pattern before it gets worse — that’s exactly the right moment to start.'
  },
  c21: {
    5: 'Five minutes, most days — short and consistent beats long and occasional.',
    10: "Ten minutes — that's the sweet spot most people land on.",
    20: "Twenty minutes — you're ready to go deeper, and the plan will meet you there.",
    30: "Thirty-plus minutes — that's real commitment, and we'll make it count."
  },
  c22: {
    earlymorning: "Early morning — before the day gets its hooks in, a good window.",
    morning: "Mid-morning — once you're settled but before the day piles up.",
    afternoon: 'Afternoon — a natural reset point when energy usually dips.',
    evening: 'Evening — winding the day down is a solid time to train.'
  },
  c23: {
    audio: "Audio, in the moment — we'll lean on guided prompts you can use live.",
    reading: "You want the why first — we'll give you the reasoning, not just the instruction.",
    practice: 'Repeat until automatic — that’s exactly how this kind of training works.',
    writing: 'Getting it out on paper — journaling prompts will be part of your plan.',
    mix: "A mix of formats — we'll vary it instead of locking you into one mode."
  },
  csq2: {
    stepback: 'Stepping back from a thought first — seeing it without following it is the core move.',
    hypothesis: 'Checking a worry like a hypothesis first — fact or forecast, that question does a lot of work.',
    selftalk: 'Believable self-talk first — steadier, not sugar-coated, is exactly the target.',
    focus: 'A focus reset first — something simple to return to, every time.',
    tinystep: "A tiny next step first — motion when you're stuck beats waiting to feel ready.",
    winddown: 'A night wind-down first — letting thoughts settle instead of solving them.',
    more: ' Good — the rest are in your plan too.'
  },
  c24: {
    streaks: "Visible progress keeps you going — we'll make the progress easy to see.",
    proof: "You want proof it's working — we'll surface the wins, not just ask you to trust it.",
    nudge: 'A gentle nudge at the right time — reminders will do the reminding.',
    shortness: "Short sessions are easier to start — we'll keep them short on purpose."
  },
  c27: {
    low: 'Your mind reaches for what could go wrong first — that’s a pattern, not a personality trait.',
    mid: 'A mix of good and bad gets your attention — pretty typical, and still shiftable.',
    high: "You mostly notice the good already — we'll help that hold up under pressure too."
  },
  c28: {
    no: "You stay separate from other people's states — that's a useful boundary to keep.",
    sometimes: 'Certain people or days get under your skin — worth knowing which ones.',
    often: "You carry other people's moods home with you — that's exhausting, and trainable.",
    always: "You soak up the whole room — we'll work on a filter, not a wall."
  },
  c29: {
    low: "Decisions rarely trip you up — good, we'll keep that steady.",
    mid: "Decisions sometimes send you looping — that's a specific, fixable trigger.",
    high: "Decisions almost always send you looping — that's one of the clearest places to intervene."
  },
  c30: {
    calm: 'A calm home gives your mind room to recover — that’s a real asset.',
    busy: "Busy but okay — you're finding pockets of quiet, and we'll help protect them.",
    chaotic: "A chaotic environment adds to the load — that's not something willpower fixes alone.",
    lonely: "Too quiet, too alone with your thoughts — that's its own kind of pressure."
  },
  c31: {
    low: 'Body and mind aren’t getting much support right now — small changes here go a long way.',
    mid: "Some support, not consistent — we'll work with what's already there.",
    high: "You're already supporting your mind well physically — that foundation will make the rest easier."
  },
  chq3: {
    push: "Noted \u2014 your plan will check in on you. Gently.",
    solo: "Got it \u2014 your plan stays out of the way and lets you lead."
  }
};

/** Maps the screen SHOWING the echo -> [containerIdOfTheAnsweredQuestion, kind]. Consumed by echoFor() (js/funnel-flow.js) and test/echoes.test.js. */
export const ECHO_SOURCE = {
  s27: ['chq3', 'choice'],
  s1: ['c0', 'choice'],
  s2: ['c1', 'scale'],
  s3: ['c2', 'choice'],
  s6: ['c5', 'multi'],
  s7: ['c6', 'scale'],
  s8: ['c7', 'choice'],
  s11: ['c10', 'choice'],
  s12: ['c11', 'scale'],
  s13: ['c12', 'scale'],
  s16: ['c15', 'choice'],
  s17: ['c16', 'scale'],
  s18: ['c17', 'scale'],
  s19: ['c18', 'choice'],
  s21: ['csq1', 'choice'],
  s22: ['c21', 'choice'],
  s23: ['c22', 'choice'],
  sq2: ['c23', 'choice'],
  s24: ['csq2', 'multi'],
  s25: ['c24', 'choice'],
  s28: ['c27', 'scale'],
  s29: ['c28', 'choice'],
  s30: ['c29', 'scale'],
  s31: ['c30', 'choice'],
  s32: ['c31', 'scale']
};

/** Reaction screen after readiness (s32 / c32) — normalize + promise, no fake urgency */
export const REACT_READY = {
  1: {
    title: 'Curious is enough to start',
    body: 'You don&rsquo;t need to feel ready. Short, low-pressure prompts are exactly how MindLift is built &mdash; a few minutes at a time, no big commitment required.'
  },
  2: {
    title: 'Interest is how every change starts',
    body: 'You don&rsquo;t need to force motivation. MindLift works in small moments &mdash; quick prompts that fit into the day you already have.'
  },
  3: {
    title: 'Ready is all it takes',
    body: 'You bring the willingness &mdash; your plan brings the structure. Short daily practice, matched to the loop pattern you&rsquo;ve just described.'
  },
  4: {
    title: 'That determination will serve you',
    body: 'Determined people often try to out-think the loop. Your plan channels that energy into something that works better: training the response instead.'
  },
  5: {
    title: 'Let&rsquo;s put that energy to work',
    body: 'Momentum like this is the best time to start. Your plan turns it into short, repeatable practice &mdash; so the change outlasts the burst.'
  }
};

export const TECHNIQUES = {
  rumination: 'Stepping back from thoughts',
  anticipation: 'Checking worry like a hypothesis',
  critic: 'Believable self-talk',
  scatter: 'Focus resets',
  shutdown: 'Tiny next steps',
  night: 'Scheduled processing + sleep habits',
  balanced: 'Resilience + optimization'
};

/** Share spec §2: shareable loop names + one-line hooks (distinct from the private/clinical LOOP_NAMES used in-quiz). */
export const LOOP_SHARE = {
  rumination: {
    name: 'The Replay',
    line: "Your mind re-runs the tape to get it right. It doesn't need to.",
    longDescription: [
      "You replay moments long after they're over — the conversation, the decision, the thing you said that maybe landed wrong. Your mind keeps re-running the tape, looking for the version where you said it better, when the moment itself is long gone and there's nothing left to actually fix.",
      "Going over things again is a very human way of trying to make sense of them; it only becomes a loop when the replaying stops helping and starts costing you the rest of your day. The tape rarely ends with resolution — it just runs until something else interrupts it. MindLift doesn't ask you to stop noticing what happened — it trains your mind to let a moment land and close instead of looping indefinitely."
    ]
  },
  anticipation: {
    name: 'Worst-Case Rehearsal',
    line: "Your mind pre-lives the bad ending so it can't surprise you.",
    longDescription: [
      "Your mind jumps straight to the worst version of what could happen, and rehearses it in detail before anything has actually gone wrong. It feels like preparation — like if you can just picture the bad outcome clearly enough, it won't be able to surprise you when it actually arrives. Naming the worst case can feel like the responsible thing to do, even when it's really just worry wearing a plan's clothing.",
      "That instinct comes from a real place: trying to protect yourself by staying one step ahead of whatever might go wrong. The trouble is the rehearsal rarely stops at one pass, and the bracing takes almost as much out of you as the actual event would, sometimes more. MindLift trains a different first move — checking the worry like a hypothesis instead of living inside it."
    ]
  },
  critic: {
    name: 'The Inner Critic Loop',
    line: 'The voice that pushes you is the one that drains you.',
    longDescription: [
      "There's a voice that runs whenever things go sideways, and it's harsher with you than you'd ever be with anyone else. It sounds like motivation — like it's keeping you sharp and stopping you from getting complacent — but it rarely lets up long enough for you to actually feel good about what you did well. Most of the time it's already moved on to the next thing you got wrong.",
      "That voice isn't discipline; it's a loop dressed up as standards, and it tends to get louder exactly when you need steadiness the most. You don't need to silence it completely to change your relationship with it — you need a version of self-talk that's steadier and more believable than either harsh criticism or forced positivity. That's the shift MindLift trains toward."
    ]
  },
  scatter: {
    name: 'The Tab-Switcher',
    line: "Your attention isn't broken. It's over-subscribed.",
    longDescription: [
      "Your attention jumps — from one thought to the next, one task to another, rarely settling long enough to finish what you started. It's not that you can't focus; it's that there's too much competing for the same narrow lane at once, all demanding attention simultaneously, so nothing quite gets the room it needs.",
      "A busy mind like yours isn't broken, it's over-subscribed, and pushing harder to concentrate usually backfires and makes the scattering worse instead of better. What tends to work instead is something small and steady to return to whenever your attention scatters, again and again, without judging yourself for needing to. MindLift trains that kind of focus reset — a landing spot, not a lecture about willpower."
    ]
  },
  shutdown: {
    name: 'The Shutdown Loop',
    line: "Going quiet isn't giving up. It's your mind hitting pause.",
    longDescription: [
      "When it gets to be too much, you go quiet. Not dramatically — you just pull back, go still, and stop engaging until the overwhelm passes. From the outside it can look like giving up; from the inside it's closer to your system hitting pause because there's simply nothing left to give right now, and pushing through would only cost more later.",
      "That shutdown is protection, not failure, even though it can leave you feeling stuck exactly when you need to move. The goal isn't to force yourself through it faster or push past it before you're ready — it's to have one small, doable next step ready for when you're ready to take it. That's what MindLift trains toward."
    ]
  },
  night: {
    name: 'The 2am Loop',
    line: "Your mind saves its hardest thinking for when you can't act on it.",
    longDescription: [
      "The quiet at night doesn't calm your mind — it activates it. The moment things go still, the thinking starts: replaying, planning, worrying, circling the same handful of thoughts long after there's anything useful left to do with them, right when you most need to rest and least have the energy to solve anything.",
      "Your mind isn't malfunctioning at night; it's just picked the worst possible, most inconvenient time to try to solve things, when there's nothing left to actually act on until morning anyway. The fix isn't forcing sleep or fighting the thoughts — it's learning to let them settle instead of chasing them to a conclusion. MindLift trains a wind-down that works with that timing instead of against it."
    ]
  }
};

/** Personalise spec §3: s4's headline + first loop-node read the loop back to the person. */
export const LOOP_METHOD = {
  rumination: { short: 'the replay', thought: '“Why did I say that?”' },
  anticipation: { short: 'worst-case rehearsal', thought: '“What if it all goes wrong?”' },
  critic: { short: 'the inner critic', thought: '“I’m not good enough.”' },
  scatter: { short: 'the scatter', thought: '“Wait — what was I doing?”' },
  shutdown: { short: 'the shutdown', thought: '“I can’t deal with this.”' },
  night: { short: 'the 2am loop', thought: '“…and another thing.”' }
};

/**
 * Personalise spec §3: s26 testimonial pairs by loop. rumination/critic share the
 * existing Priya M. / James K. pair (the only two real, already-live testimonials
 * in this codebase). The other four pairs are new and marked illustrative:true —
 * docs/testimonials.md does not exist in this repo; see Task 7's testimonials check.
 */
export const LOOP_TESTIMONIALS = {
  rumination: [
    { quote: "I'd been in therapy for two years. I understood my anxiety completely. MindLift was the first thing that gave me something to actually do when it was happening. That's the part that was missing.", avatar: '👩🏽', name: 'Priya M., 34', role: 'Teacher · London' },
    { quote: 'I thought I had a focus problem. MindLift showed me I had a thought-loop problem that was exhausting my attention. Completely different fix.', avatar: '👨🏻', name: 'James K., 28', role: 'Software engineer · Berlin' }
  ],
  critic: [
    { quote: "I'd been in therapy for two years. I understood my anxiety completely. MindLift was the first thing that gave me something to actually do when it was happening. That's the part that was missing.", avatar: '👩🏽', name: 'Priya M., 34', role: 'Teacher · London' },
    { quote: 'I thought I had a focus problem. MindLift showed me I had a thought-loop problem that was exhausting my attention. Completely different fix.', avatar: '👨🏻', name: 'James K., 28', role: 'Software engineer · Berlin' }
  ],
  anticipation: [
    { quote: 'I used to run every meeting five times in my head before it happened. MindLift taught me to notice the rehearsal and just stop rehearsing.', avatar: '👩🏾', name: 'Maya T., 29', role: 'Product manager · Austin', illustrative: true },
    { quote: 'I thought planning for the worst was being responsible. Turns out it was just anxiety wearing a to-do list.', avatar: '👨🏼', name: 'Owen R., 41', role: 'Consultant · Toronto', illustrative: true }
  ],
  scatter: [
    { quote: "My mind used to have twelve tabs open at once. I'm down to two, most days — and I can finish one before starting the next.", avatar: '👩🏻', name: 'Lena K., 26', role: 'Designer · Amsterdam', illustrative: true },
    { quote: 'I always thought I just had a short attention span. It was closer to an overloaded one. The resets gave me somewhere to land.', avatar: '👨🏿', name: 'Marcus D., 33', role: 'Teacher · Chicago', illustrative: true }
  ],
  shutdown: [
    { quote: 'When it got to be too much, I used to just go quiet for days. Now I notice the shutdown starting and have something small to do instead of nothing.', avatar: '👩🏽', name: 'Ana P., 37', role: 'Nurse · Lisbon', illustrative: true },
    { quote: "I called it laziness for years. It wasn't laziness — it was my system pulling the plug. Knowing that changed how I talk to myself.", avatar: '🧑🏻', name: 'Sam W., 30', role: 'Freelancer · Melbourne', illustrative: true }
  ],
  night: [
    { quote: "I'd lie awake solving problems that weren't solvable at 2am. The night wind-down is the first thing that's actually gotten me back to sleep.", avatar: '👩🏽', name: 'Farah N., 34', role: 'Physician · Dubai', illustrative: true },
    { quote: 'My best and worst thinking both happen at midnight. Now at least the worst thinking has an off-ramp.', avatar: '👨🏻', name: 'Devon L., 27', role: 'Software engineer · Seattle', illustrative: true }
  ]
};

/** Personalise spec §9: loop -> accent-tint CSS custom property, used on ms2's flag and s26's avatar tint.
 * Only 4 illo colours exist (ochre/sage/blush/rose — see ILLO_VARS in scripts/build-share-images.mjs
 * and js/share.js), so with 6 loops, tints repeat by design (rumination/night both ochre, shutdown/scatter
 * both rose); this is not a bug to "fix" by adding more colours. */
export const LOOP_TINT = {
  rumination: '--illo-ochre',
  anticipation: '--illo-blush',
  critic: '--illo-sage',
  scatter: '--illo-rose',
  shutdown: '--illo-rose',
  night: '--illo-ochre'
};

/** Personalise spec §4: one reaction line per "what have you tried" pick, in TRIED_REACTIONS order matching #c8's data-v values. */
export const TRIED_REACTIONS = {
  meditation: 'Meditation calms the thought down. It doesn’t change what you do the next time the thought shows up — so the loop waits for you.',
  therapy: 'Therapy gives you the map: why the loop is there. MindLift is the in-the-moment part — what to do at 3pm when it starts.',
  apps: 'Most wellness apps are 20-minute sessions you do later. The loop happens now. You need something that fits inside the moment.',
  exercise: 'Exercise burns the charge off — for a while. It resets your body, not the pattern your mind runs when it’s quiet again.',
  none: 'No habits to unlearn and no “I already tried that” — you get to start with the part that actually interrupts the loop.'
};

/** Personalise spec §5: body-location phrase (c13) and time-of-day phrase (c2), combined by patternSentence() in js/funnel-analysis.js. */
export const BODY_PHRASES = {
  chest: 'lands as a tight chest',
  stomach: 'lands in your stomach',
  head: 'lands as pressure in your head',
  jaw: 'lands in a clenched jaw and shoulders',
  fatigue: 'drains your whole body',
  none: ''
};
export const TIME_PHRASES = {
  morning: 'in the morning, before the day has started',
  transitions: 'in the gaps between things',
  conflict: 'after conversations',
  decisions: 'when there’s a decision to make',
  night: 'at night',
  constant: 'all day'
};
